<template>
  <div class="nkdForm">
    <div class="userName">
      <span>姓名：</span>
      <el-input placeholder="填写您的真实姓名"
                v-model="userName"
                clearable
                style="width: 70%;margin-right: 10px">
      </el-input>
    </div>
    <div class="idCardType">
      <span style="flex:4">证件类型：</span>
      <div class="idCardTypeRadio">
        <el-radio v-model="idCardTypeRadio" @change="idCardTypeChange(idCardTypeRadio)" label="居民身份证">居民身份证</el-radio>
        <el-radio v-model="idCardTypeRadio" @change="idCardTypeChange(idCardTypeRadio)" label="其他">其他</el-radio>
      </div>
    </div>
    <div class="idCardType" v-if="idCardTypeRadio === '其他'">
      <span>证件类型：</span>
      <el-select v-model="idCardType"
                 style="width: 70%;margin-right: 10px">
        <el-option
          v-for="(item,index) in idCardTypeOptions"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
    </div>
    <div class="idCard">
      <span>证件号码：</span>
      <el-input placeholder="请输入正确的证件号码"
                v-model="idCard"
                clearable
                @input="idCardChange"
                @change="idCardChangeValue"
                style="width: 70%;margin-right: 10px">
      </el-input>
    </div>
    <div class="country" v-if="idCardTypeRadio === '其他'">
      <span>国籍：</span>
      <el-select v-model="country"
                 style="width: 70%;margin-right: 10px">
        <el-option
          v-for="(item,index) in countryOptions"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
    </div>
    <div class="sex" v-if="idCardTypeRadio === '其他'">
      <span style="flex:4">性别：</span>
      <div class="sexRadio">
        <el-radio v-model="sexRadio" label="男" >先生</el-radio>
        <el-radio v-model="sexRadio" label="女" >女士</el-radio>
      </div>
    </div>

    <div class="age" v-if="idCardTypeRadio === '其他'">
      <span>年龄：</span>
      <el-input placeholder="请输入您的真实年龄"
                v-model="age"
                clearable
                style="width: 70%;margin-right: 10px">
      </el-input>
    </div>
    <div class="phone">
      <span>联系方式：</span>
      <el-input placeholder="填写您的手机号码"
                v-model="phone"
                clearable
                style="width: 70%;margin-right: 10px">
      </el-input>
    </div>

    <div class="gap"></div>

    <div class="department">
      <span style="width: 120px">部门：</span>
      <el-input placeholder="填写您的部门"
                v-model="department"
                clearable
                style="width: 70%;margin-right: 10px">
      </el-input>
    </div>
    <div class="userNumber">
      <span>工号/学号：</span>
      <el-input placeholder="填写您的工号/学号"
                v-model="userNumber"
                clearable
                style="width: 70%;margin-right: 10px">
      </el-input>
    </div>
    <div class="type">
      <span style="flex:4">类型：</span>
      <div class="typeRadio">
        <el-radio v-model="type" label="因公">因公</el-radio>
        <el-radio v-model="type" label="因私">因私</el-radio>
      </div>
    </div>
    <div class="isToDoor">
      <span style="flex:4">是否需要上门采样：</span>
      <div class="isToDoorRadio">
        <el-radio v-model="isToDoor" label="否">否</el-radio>
        <el-radio v-model="isToDoor" label="是">是</el-radio>
      </div>
    </div>
    <div class="address">
      <span>采样地址：</span>
      <div v-if="isToDoor === '否'" class="addressMsg">南山智园A4栋6楼</div>
      <el-input v-if="isToDoor === '是'"
                placeholder="请输入上门采样地址"
                v-model="addressMsg"
                clearable
                style="width: 70%;margin-right: 10px">
      </el-input>
    </div>
    <div class="contacts">
      <span>核子华曦联系人：</span>
      <div class="contactsMsg">
        <div>
          李盛 <a href="tel:18670785253">18670785253</a>
        </div>
        <div>
          叶泉 <a href="tel:17665353615">17665353615</a>
        </div>
      </div>
    </div>

    <div class="gap"></div>

    <div class="appointmentDate">
      <span>预约日期：</span>
      <el-select v-model="appointmentDate"
                 style="width: 70%;margin-right: 10px">
        <el-option
          v-for="(item,index) in appointmentDateOptions"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>

    </div>
    <div class="appointmentTime">
      <span>预约时间：</span>
      <el-select v-model="appointmentTime"
                 style="width: 70%;margin-right: 10px">
        <el-option
          v-for="(item,index) in appointmentTimeOptions"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
    </div>
    <div class="remarks">
      <span>备注：</span>
      <el-input v-model="remarks"
                clearable
                size="small"
                style="width: 65%;margin-right: 10px">
      </el-input>
    </div>

    <div class="gap history" style="height: 35px">
      <p @click="toHistory">历史预约信息</p>
    </div>

    <div class="submit">
      <el-button type="primary"
                 :disabled="isClick"
                 @click="submit"
                 style="width: 70%;margin-top: 20px">
        提交</el-button>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import {request} from "../../network/request";

  import  storage from '../../model/storage.js'
  import qs from 'qs';

  export default {
      name: "nkdForm",
      data() {
        return {
          country: '中国',
          countryOptions: [
          '中国',
          '中国澳门',
          '中国台湾',
          '中国香港',
          '韩国',
          '日本',
          '意大利',
          '西班牙',
          '法国',
          '德国',
          '美国',
          '加拿大',
          '新加坡',
          '马来西亚',
          '巴林',
          '阿联酋',
          '瑞士',
          '荷兰',
          '英国',
          '瑞典',
          '澳大利亚',
          '新西兰',
          '巴西',
          '阿根廷',
          '伊朗',
          '阿富汗',
          '阿尔巴尼亚',
          '南极洲',
          '阿尔及利亚',
          '美属萨摩亚',
          '安道尔',
          '安哥拉',
          '安提瓜和巴布达',
          '阿塞拜疆',
          '奥地利',
          '巴哈马',
          '孟加拉国',
          '亚美尼亚',
          '巴勒斯坦',
          '巴巴多斯',
          '比利时',
          '百慕大',
          '不丹',
          '玻利维亚',
          '波黑',
          '博茨瓦纳',
          '布维岛',
          '伯利兹',
          '英属印度洋领地',
          '所罗门群岛',
          '英属维尔京群岛',
          '文莱',
          '保加利亚',
          '缅甸',
          '布隆迪',
          '白俄罗斯',
          '柬埔寨',
          '喀麦隆',
          '佛得角',
          '开曼群岛',
          '中非',
          '斯里兰卡',
          '乍得',
          '智利',
          '圣诞岛',
          '科科斯（基林）群岛',
          '哥伦比亚',
          '科摩罗',
          '马约特',
          '刚果（布）',
          '刚果（金）',
          '库克群岛',
          '哥斯达黎加',
          '克罗地亚',
          '古巴',
          '塞浦路斯',
          '捷克',
          '贝宁',
          '丹麦',
          '多米尼克',
          '多米尼加',
          '厄瓜多尔',
          '萨尔瓦多',
          '赤道几内亚',
          '埃塞俄比亚',
          '厄立特里亚',
          '爱沙尼亚',
          '法罗群岛',
          '福克兰群岛（马尔维纳斯群岛）',
          '南乔治亚岛和南桑德韦奇岛',
          '斐济',
          '芬兰',
          '奥兰群岛',
          '法属圭亚那',
          '法属波利尼西亚',
          '法属南部领地',
          '吉布提',
          '加蓬',
          '格鲁吉亚',
          '冈比亚',
          '加纳',
          '直布罗陀',
          '基里巴斯',
          '希腊',
          '格陵兰',
          '格林纳达',
          '瓜德罗普',
          '关岛',
          '危地马拉',
          '几内亚',
          '圭亚那',
          '海地',
          '赫德岛和麦克唐纳岛',
          '梵蒂冈',
          '洪都拉斯',
          '匈牙利',
          '冰岛',
          '印度',
          '印度尼西亚',
          '伊拉克',
          '爱尔兰',
          '以色列',
          '科特迪瓦',
          '牙买加',
          '哈萨克斯坦',
          '约旦',
          '肯尼亚',
          '朝鲜',
          '科威特',
          '吉尔吉斯斯坦',
          '老挝',
          '黎巴嫩',
          '莱索托',
          '拉脱维亚',
          '利比里亚',
          '利比亚',
          '列支敦士登',
          '立陶宛',
          '卢森堡',
          '马达加斯加',
          '马拉维',
          '马尔代夫',
          '马里',
          '马耳他',
          '马提尼克',
          '毛里塔尼亚',
          '毛里求斯',
          '墨西哥',
          '摩纳哥',
          '蒙古',
          '摩尔多瓦',
          '黑山',
          '蒙特塞拉特',
          '摩洛哥',
          '莫桑比克',
          '阿曼',
          '纳米比亚',
          '瑙鲁',
          '尼泊尔',
          '荷属安的列斯',
          '阿鲁巴',
          '新喀里多尼亚',
          '瓦努阿图',
          '尼加拉瓜',
          '尼日尔',
          '尼日利亚',
          '纽埃',
          '诺福克岛',
          '挪威',
          '北马里亚纳',
          '美国本土外小岛屿',
          '密克罗尼西亚',
          '马绍尔群岛',
          '帕劳',
          '巴基斯坦',
          '巴拿马',
          '巴布亚新几内亚',
          '巴拉圭',
          '秘鲁',
          '菲律宾',
          '皮特凯恩群岛',
          '波兰',
          '葡萄牙',
          '几内亚比绍',
          '东帝汶',
          '波多黎各',
          '卡塔尔',
          '留尼汪',
          '罗马尼亚',
          '俄罗斯',
          '卢旺达',
          '圣赫勒拿',
          '圣基茨和尼维斯',
          '安圭拉',
          '圣卢西亚',
          '圣皮埃尔和密克隆',
          '圣文森特和格林纳丁斯',
          '圣马力诺',
          '圣多美和普林西比',
          '沙特阿拉伯',
          '塞内加尔',
          '塞尔维亚',
          '塞舌尔',
          '塞拉利昂',
          '斯洛伐克',
          '越南',
          '斯洛文尼亚',
          '索马里',
          '南非',
          '津巴布韦',
          '西撒哈拉',
          '苏丹',
          '苏里南',
          '斯瓦尔巴岛和扬马延岛',
          '斯威士兰',
          '叙利亚',
          '塔吉克斯坦',
          '泰国',
          '多哥',
          '托克劳',
          '汤加',
          '特立尼达和多巴哥',
          '突尼斯',
          '土耳其',
          '土库曼斯坦',
          '特克斯和凯科斯群岛',
          '图瓦卢',
          '乌干达',
          '乌克兰',
          '北马其顿',
          '埃及',
          '格恩西岛',
          '泽西岛',
          '英国属地曼岛',
          '坦桑尼亚',
          '美属维尔京群岛',
          '布基纳法索',
          '乌拉圭',
          '乌兹别克斯坦',
          '委内瑞拉',
          '瓦里斯和福图纳',
          '萨摩亚',
          '也门',
          '赞比亚',
        ],
          idCardTypeRadio: '居民身份证',
          idCardType: '居民身份证',
          idCardTypeOptions: [
            '护照',
            '港澳居民来往内地通行证（俗称回乡证）',
            '台湾居民来往内地通行证（俗称台胞证）',
            '出生医学证明',
            '其他'
          ],
          idCard: '',
          userName: '',
          sexRadio: '先生',
          age: '',
          phone: '',
          department: '',
          userNumber: '',
          type: '因公',
          isToDoor: '否',
          address: '南山智园A4栋6楼',
          addressMsg: '',
          remarks: '',
          isClick: false,
          appointmentDate: '',
          appointmentDateOptions: [],
          appointmentTime: '10:30-12:00',
          appointmentTimeOptions: [
            '10:30-12:00',
            '14:00-17:00'
          ],
        }
      },
      // created() {
      //   let authUser =  storage.get('authUser')
      //   console.log(authUser)
      //   if (!authUser) {
      //     const {state,code,mangerId,storeId} = qs.parse(location.href.split('?')[1]) || {};
      //     console.log(location.href)
      //     console.log('state:',state,'code:',code)
      //     if(state && code) {
      //       console.log('state:',state,'code:',code)
      //       this.$axios.get("https://wx.hezijiyin.com/api/wechat/user/profile",{
      //         params: {
      //           state: state,
      //           code: code
      //         }
      //       }).then(responseJson => {
      //         console.log(responseJson.data.token)
      //         storage.set('token',responseJson.data.token)
      //         storage.set('authUser',1)
      //         this.$router.push({
      //           path: '/nkd',
      //           name: 'nkdForm'
      //         });
      //       })
      //     }else{
      //       console.log('第一次')
      //       //第一次
      //       const locationHref = location.href
      //       const baseUrl = 'https://wx.hezijiyin.com/api'
      //       console.log(locationHref,baseUrl)
      //       let url = `${baseUrl}/wechat/user/login?redirect_uri=${encodeURIComponent(locationHref)}`
      //       console.log(url)
      //       location.href = `${baseUrl}/wechat/user/login?redirect_uri=${encodeURIComponent(locationHref)}`
      //     }
      //
      //   }
      // },
      mounted() {
        let today = new Date();
        let date = new Date();
        let date1 = new Date();
        let date2 = new Date();
        let date3 = new Date();
        let date4 = new Date();
        let date5 = new Date();
        let date6 = new Date();
        let date7 = new Date();
        let date8 = new Date();
        let date9 = new Date();
        let date10 = new Date();
        let date11 = new Date();
        let date12 = new Date();
        let date13 = new Date();
        date.setTime(date.getTime()+24*60*60*1000)
        date1.setTime(date1.getTime()+24*60*60*1000*2)
        date2.setTime(date2.getTime()+24*60*60*1000*3)
        date3.setTime(date3.getTime()+24*60*60*1000*4)
        date4.setTime(date4.getTime()+24*60*60*1000*5)
        date5.setTime(date5.getTime()+24*60*60*1000*6)
        date6.setTime(date6.getTime()+24*60*60*1000*7)
        date7.setTime(date7.getTime()+24*60*60*1000*8)
        date8.setTime(date8.getTime()+24*60*60*1000*9)
        date9.setTime(date9.getTime()+24*60*60*1000*10)
        date10.setTime(date10.getTime()+24*60*60*1000*11)
        date11.setTime(date11.getTime()+24*60*60*1000*12)
        date12.setTime(date12.getTime()+24*60*60*1000*13)
        date13.setTime(date13.getTime()+24*60*60*1000*14)
        let today1 = this.dateFormat('YYYY-mm-dd',today);
        let day1 = this.dateFormat('YYYY-mm-dd',date);
        let day2 = this.dateFormat('YYYY-mm-dd',date1);
        let day3 = this.dateFormat('YYYY-mm-dd',date2);
        let day4 = this.dateFormat('YYYY-mm-dd',date3);
        let day5 = this.dateFormat('YYYY-mm-dd',date4);
        let day6 = this.dateFormat('YYYY-mm-dd',date5);
        let day7 = this.dateFormat('YYYY-mm-dd',date6);
        let day8 = this.dateFormat('YYYY-mm-dd',date7);
        let day9 = this.dateFormat('YYYY-mm-dd',date8);
        let day10 = this.dateFormat('YYYY-mm-dd',date9);
        let day11 = this.dateFormat('YYYY-mm-dd',date10);
        let day12 = this.dateFormat('YYYY-mm-dd',date11);
        let day13 = this.dateFormat('YYYY-mm-dd',date12);
        let day14 = this.dateFormat('YYYY-mm-dd',date13);
        this.appointmentDate = today1
        this.appointmentDateOptions =[
            today1,day1,day2,day3,day4,day5,day6,day7,day8,day9,day10,day11,day12,day13,day14
        ]
      },
      methods: {
        idCardTypeChange(idCardType) {
          this.idCardType = idCardType
          if(idCardType  === '居民身份证') {
            this.idCardType = '居民身份证'
            this.country = '中国'
            this.idCardComputed()
          }
        },
        idCardComputed() {
          if(this.idCard.length >= 18 && this.idCardType === '居民身份证') {
            let idCard = this.idCard.substr(0,18).toUpperCase()
            this.idCard = idCard
            console.log(idCard)
            if(this.idCardType === "居民身份证" && !this.id_card_mix(idCard)) {
              // this.$message.error('请核实身份证信息')
              console.log('请核实身份证信息')
              return;
            }
            console.log('过了校验')

            const agesex = this.analyzeIDCard(this.idCard);
            console.log(agesex)
            if (agesex.sex === '男') {
              this.sexRadio = '男'
            }else {
              this.sexRadio = '女'
            }
            this.age = agesex.age
            this.sexRadio = agesex.sex
            this.birthday = agesex.birthday
          }
        },
        dateFormat(fmt, date) {
          let ret;
          const opt = {
            "Y+": date.getFullYear().toString(),        // 年
            "m+": (date.getMonth() + 1).toString(),     // 月
            "d+": date.getDate().toString(),            // 日
            "H+": date.getHours().toString(),           // 时
            "M+": date.getMinutes().toString(),         // 分
            "S+": date.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
          };
          for (let k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
              fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
            }
          }
          return fmt;
        },
        idCardChange(value) {
          console.log("idCardChange",value)
          let idCardType = this.idCardType
          // console.log(idCardType)
          if(value.length >= 18 && idCardType === '居民身份证') {
            let idCard = value.substr(0,18).toUpperCase()
            this.idCard = idCard
            if(idCardType === "居民身份证" && !this.id_card_mix(idCard)) {
              // this.$message.error('请核实身份证信息')
              console.log('请核实身份证信息')
              return;
            }
            const agesex = this.analyzeIDCard(value);
            console.log(agesex)
            if (agesex.sex === '男') {
              this.sexRadio = '男'
            }else {
              this.sexRadio = '女'
            }
            this.age = agesex.age
            this.sexRadio = agesex.sex
          }
        },
        idCardChangeValue() {
          if(this.idCardType === "居民身份证" && !this.id_card_mix(this.idCard)) {
            this.$message.error('请核实身份证信息');
            return;
          }
        },
        id_card_mix(code){
          var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
          var tip = "";
          var pass = true;
          var reg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/;
          if (!code || !code.match(reg)) {
            tip = "身份证号格式错误";
            pass = false;
          }else if (!city[code.substr(0, 2)]) {
            tip = "地址编码错误";
            pass = false;
          }else {
            //18位身份证需要验证最后一位校验位
            if (code.length == 18) {
              code = code.split('');
              //∑(ai×Wi)(mod 11)
              //加权因子
              var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
              //校验位
              var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
              var sum = 0;
              var ai = 0;
              var wi = 0;
              for (var i = 0; i < 17; i++) {
                ai = code[i];
                wi = factor[i];
                sum += ai * wi;
              }
              var last = parity[sum % 11];
              if (parity[sum % 11] != code[17]) {
                tip = "校验位错误";
                pass = false;
              }
            }
          }

          if(pass) return true;
          return false;
        },
        analyzeIDCard(IDCard) {
          let sexAndAge = {};
          // 获取用户身份证号码
          let userCard = IDCard;
          // 如果身份证号码为 undefind 则返回空
          if (!userCard) {
            return sexAndAge;
          }
          // 获取性别
          if (parseInt(userCard.substr(16, 1)) % 2 == 1) {
            sexAndAge.sex = '男'
          } else {
            sexAndAge.sex = '女'
          }
          // 获取出生年月日
          //userCard.substring(6,10) + "-" + userCard.substring(10,12) + "-" + userCard.substring(12,14);
          let yearBirth = userCard.substring(6, 10);
          let monthBirth = userCard.substring(10, 12);
          let dayBirth = userCard.substring(12, 14);
          let birthday = yearBirth + '-' + monthBirth + '-' + dayBirth
          // 获取当前年月日并计算年龄
          let myDate = new Date();
          let monthNow = myDate.getMonth() + 1;
          let dayNow = myDate.getDay();
          let age = myDate.getFullYear() - yearBirth;
          if (monthNow < monthBirth || (monthNow == monthBirth && dayNow < dayBirth)) {
            age--;
          }
          //得到出生日期
          sexAndAge.birthday = birthday;
          // 得到年龄
          sexAndAge.age = age;
          // 返回性别和年龄
          return sexAndAge;
        },
        msgCheck() {
          if(!this.idCard) return '请输入证件号码'
          let role=/^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|30|31)|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/
          if(this.idCardType === "居民身份证"&&!role.test(this.idCard)) return '居民身份证格式错误'
          if(!this.userName) return '请输入姓名'
          if(!this.age) return '请输入年龄'
          if(!this.phone) return '请输入手机号'
          if(!/^1[3456789]\d{9}$/.test(this.phone)) return '手机格式错误'
          if(this.isToDoor === "是"&&!this.addressMsg) return '请填写上门采样地址'
          return ;
        },
        submit() {
          this.isClick = true
          let _this = this
          let msg = this.msgCheck()
          if(msg){
            this.$message.error({
              message: msg,
              duration: 2000,
              onClose() {
                _this.isClick = false
              }
            })
            return;
          }

          let address = this.isToDoor === '否' ? this.address : this.addressMsg
          let isToDoor = this.isToDoor === '否' ? '0' : '1'
          let type = this.type === '因公' ? '0' : '1'


          // 正式环境
          // let url = 'https://wx.hezijiyin.com/api/order/appointment/form_nkd'
          // 测试环境
          // let url = 'https://admin.hxyljk.com/public/api.php/order/appointment/form_nkd'

          // 测试环境
          this.$axios.post(
            // 'https://admin.hxyljk.com/public/api.php/order/appointment/form_nkd',
            this.$qs.stringify({
              country: this.country,
              card_type: this.idCardType,
              id_card: this.idCard,
              full_name: this.userName,
              gender: this.sexRadio,
              age: this.age,
              phone: this.phone,
              department: this.department,
              number: this.userNumber,
              type: type,
              is_door: isToDoor,
              collection_address: address,
              appointment_date: this.appointmentDate,
              appointment_time: this.appointmentTime,
              remark: this.remarks
            })
            ,{
              headers: {
                'Authorization': 'bearer' + storage.get('token'),
              }
            }
          ).then(function(res){
            console.log(res)
            if(res.data.code === 200) {
              _this.$message({
                message: '预约成功',
                type: 'success',
                duration: 2000,
                onClose() {
                  _this.$router.push({
                    path: '/nkd_list',
                    name: 'nkdList'
                  })
                }
              })
            }else{
              _this.$message.error({
                message: res.data.content,
                onClose() {
                  _this.isClick = false
                }
              })
            }

          })
            .catch(function(error){
              console.log(error)
            })
        },
        toHistory() {
          this.$router.push({
            path: '/nkd_list',
            name: 'nkdList'
          })
        }
      }
    }
</script>

<style scoped>
  .nkdForm{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow-y: auto;
  }
  .gap{
    width: auto;
    height: 15px;
    background-color: #edebeb;
  }
  span{
    font-size: 1.1rem;
    height: 40px;
    line-height: 40px;
    padding-left: 15px;
    display: flex;
    white-space: nowrap;
  }
  .country>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .idCardType>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .idCard>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .userName>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .age>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .phone>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .department>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
    width: 200px;
    padding: 0;
  }
  .userNumber>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .address>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .appointmentDate>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .appointmentTime>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .remarks>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .userName>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .idCard>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }

  .age>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .phone>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .department>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .userNumber>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .address>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .remarks>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .sexRadio,.typeRadio,.idCardTypeRadio{
    flex: 10;
    display: flex;
    align-items: center;
    height: 40px;
  }

  .isToDoorRadio{
    display: flex;
    flex: 3.5;
    align-items: center;
    height: 40px;
  }

  .isToDoorRadio>>>.el-radio__label{
    font-size: 1.1rem;
  }
  .typeRadio>>>.el-radio__label{
    font-size: 1.1rem;
  }
  .sexRadio>>>.el-radio__label{
    font-size: 1.1rem;
  }

  .country,
  .idCardType,
  .idCard,
  .userName,
  .sex,
  .age,
  .phone,
  .department,
  .userNumber,
  .type,
  .isToDoor,
  .address,
  .appointmentDate,
  .appointmentTime,
  .remarks,
  .department{
    display: flex;
    justify-content: space-between;
    height: 40px;
    border-bottom: 1px solid #f1f4f8;
  }

  .addressMsg{
    display: inline-block;
    height: 40px;
    line-height: 40px;
    width: 65%;
  }
  .contacts {
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid #f1f4f8;

  }
  .contactsMsg{
    width: 55%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 15px;
  }
  a {
    text-decoration: none;
    color: #4a90e2;
  }
  .history{
    display: flex;
    justify-content: center;
    align-items: center;
    color: #6e8fba;
    font-size: 14px;
  }
  .submit{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/nkd/nkdForm.vue